/*
  Nice Candy: Produktseite
  1. Mitlaufende Kaufleiste unten: übernimmt die oben gewählte Größe/Sorte (vorher blieb sie bei der ersten Variante)
     und zeigt den Preis direkt im Knopf ("In den Warenkorb · 9,99 €") sowie die gewählte Variante als kleinen Text.
  2. Lange Produktbeschreibungen werden eingeklappt und lassen sich mit "Mehr lesen" aufklappen.
*/
(function () {
  if (window.ncProductInit) return;
  window.ncProductInit = true;

  function mainForm() { return document.querySelector('main product-form form, main form[action*="/cart/add"]'); }

  function currentPrice() {
    var price = document.querySelector('main .product__info-container .price, main [id^="price-"] .price');
    if (!price) return '';
    var el = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim() : '';
  }

  // Das Theme zeigt am Handy eine Kopie der Leiste (in .dbtfy-toast-box), deshalb alle Leisten angleichen
  function syncSticky() {
    var form = mainForm();
    if (!form) return;
    var mainId = form.querySelector('[name="id"]');
    var price = currentPrice();
    document.querySelectorAll('.dbtfy-addtocart-sticky').forEach(function (bar) {
      var select = bar.querySelector('select[name="id"]');
      var label = '';
      if (select && mainId && mainId.value) {
        if (select.value !== mainId.value) select.value = mainId.value;
        var opt = select.options[select.selectedIndex];
        if (opt) label = opt.textContent.replace(/\s+/g, ' ').split(' - ')[0].trim();
      }
      var info = bar.querySelector('.dbtfy-addtocart-sticky-left > div:last-child');
      if (info) {
        var v = info.querySelector('.nc-sticky-variant');
        if (!v) { v = document.createElement('span'); v.className = 'nc-sticky-variant'; info.appendChild(v); }
        v.textContent = label;
        v.hidden = !label;
      }
      var btnText = bar.querySelector('button[name="add"] > span');
      if (btnText && !bar.querySelector('button[name="add"][disabled]')) {
        btnText.textContent = 'In den Warenkorb' + (price ? ' · ' + price : '');
      }
    });
  }

  function initSticky() {
    syncSticky();
    var form = mainForm();
    if (form) form.addEventListener('change', function () { setTimeout(syncSticky, 60); setTimeout(syncSticky, 400); });
    var price = document.querySelector('main .product__info-container .price, main [id^="price-"]');
    if (price) new MutationObserver(function () { syncSticky(); }).observe(price, { childList: true, subtree: true, characterData: true });
    // Die Kopie entsteht erst beim Scrollen, dann sofort angleichen
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('.dbtfy-addtocart-sticky') || n.querySelector('.dbtfy-addtocart-sticky'))) { syncSticky(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncSticky, 60); });
    }
  }

  function initReadMore() {
    var block = document.querySelector('main [id$="__nc_description"]');
    if (!block || block.dataset.ncReadmore) return;
    block.dataset.ncReadmore = '1';
    var body = block.querySelector('.rte') || block;
    if (body.scrollHeight < 340) return;
    body.classList.add('nc-desc-body');
    block.classList.add('nc-desc-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nc-readmore';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Mehr lesen';
    btn.addEventListener('click', function () {
      var open = block.classList.toggle('nc-desc-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
    });
    body.parentNode.insertBefore(btn, body.nextSibling);
  }

  function init() { initSticky(); initReadMore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
